import { useTranslation } from '@wix/wix-i18n-config';
import React from 'react';
import s from './Footer.scss';
import { dataHooks } from '../../datahooks';
import { Box, Button, Divider, Loader, TextButton } from '@wix/design-system';
import { ChevronRight, ChevronLeft } from 'wix-ui-icons-common';
import { useBusinessCreationFlow } from './useBusinessCreationFlow';
import { useViewport } from '../../hooks/useViewport';

interface FooterProps {
  onClick?: () => void;
  onPrevious?: () => void;
  isDisabled?: boolean;
  isLoading?: boolean;
  nextButtonText?: string;
  showSuffixIcon?: boolean;
  className?: string;
  skin?: 'standard' | 'light' | 'premium';
  button?: any;
}

export function Footer({
  onClick,
  isDisabled,
  onPrevious,
  isLoading,
  nextButtonText,
  showSuffixIcon = true,
  className,
  skin,
  button,
}: FooterProps) {
  const { t } = useTranslation();
  const { showLoading, handleButtonClick } = useBusinessCreationFlow({
    isLoading: isLoading || false,
    onComplete: onClick,
  });

  const { isMobile } = useViewport();
  const isPreviousButtonVisible = onPrevious && !isMobile;

  return (
    <Box className={`${s.footerWrapper} ${className || ''}`} direction="vertical" gap={8}>
      {!isMobile && <Divider />}

      <Box
        className={s.footerButtons}
        direction="horizontal"
        dataHook={dataHooks.dsBuilderFooter}
        verticalAlign="middle"
        boxSizing="border-box"
        width="100%"
        align={isPreviousButtonVisible ? 'space-between' : 'right'}
      >
        {isPreviousButtonVisible && (
          <TextButton
            prefixIcon={<ChevronLeft />}
            onClick={onPrevious}
            priority="secondary"
            dataHook={dataHooks.dsBuilderFooterBackButton}
          >
            {t('BACK')}
          </TextButton>
        )}
        {button}
        {!button && (
          <Button
            suffixIcon={!showLoading && showSuffixIcon ? <ChevronRight /> : undefined}
            onClick={!showLoading ? handleButtonClick : undefined}
            disabled={isDisabled}
            priority="primary"
            {...(skin && { skin })}
            dataHook={dataHooks.dsBuilderFooterNextButton}
          >
            {showLoading ? <Loader size="tiny" /> : nextButtonText || t('NEXT')}
          </Button>
        )}
      </Box>
    </Box>
  );
}
